/**
 * Environment utilities shared across the application.
 *
 * Ensures critical public environment variables are present at build time so
 * we never emit incorrect canonical URLs or sitemap entries.
 */

const rawSiteUrl = process.env.NEXT_PUBLIC_SITE_URL;

if (!rawSiteUrl || rawSiteUrl.trim().length === 0) {
  throw new Error(
    "Missing NEXT_PUBLIC_SITE_URL. Set it to your production origin (e.g. https://example.com) in every environment."
  );
}

let parsedSiteUrl: URL;
try {
  parsedSiteUrl = new URL(rawSiteUrl);
} catch {
  throw new Error(
    `NEXT_PUBLIC_SITE_URL must be an absolute URL including protocol (received "${rawSiteUrl}").`
  );
}

/**
 * Normalised site origin without trailing slash.
 */
export const SITE_URL = parsedSiteUrl.origin;

/**
 * Metadata base URL used by Next.js to resolve relative URLs in metadata.
 */
export const METADATA_BASE_URL = new URL(SITE_URL);

/**
 * Convert a relative path or absolute URL to an absolute URL rooted at SITE_URL.
 */
export function toAbsoluteUrl(pathOrUrl: string): string {
  if (!pathOrUrl) {
    return SITE_URL;
  }

  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }

  const normalisedPath = pathOrUrl.startsWith("/")
    ? pathOrUrl
    : `/${pathOrUrl}`;

  return `${SITE_URL}${normalisedPath}`;
}




